import { Component, OnInit, OnDestroy, Output, EventEmitter, Inject } from '@angular/core';
import { Store } from '@src/store';
import * as _ from 'lodash';
import { projectActions } from '@src/store/reducers/projectReducer';
// import { testThemeStatuses } from '@src/constants';
// import { backupsActions } from '@src/store/reducers/backupsReducer';
import moment from 'moment';
const PAGE_SIZE = 15;

@Component({
    selector: 'backups-filter',
    template: require('./backups-filter.component.html'),
    styles: [require('./backups-filter.component.scss')]
})


export class BackupsFilterComponent implements OnInit, OnDestroy {



    @Output() public filter = new EventEmitter();
    @Output() public getEnvs = new EventEmitter();

    public envs: any[] = [];
    public validation: any[] = [{ name: "All" }, { name: "Valid" }, { name: "Invalid" }];
    public selectedValidation: string = 'All';
    public pageId: number = 1;
    public quantity: number = PAGE_SIZE;
    public envTypes: any[] = [];
    public envAllClicked: boolean = false;
    public envTypeAllClicked: boolean = false;
    public selectedEnvironments: any[] = [];
    public isEmptyArr: boolean = false;
    public strEnv: string = "All"
    public envNames: string[] = []
    public unSubscribe: any;
    public fromDate: Date;
    public pushEnvElements: boolean = true;
    public initFrom: boolean;
    public initTo: boolean;
    public isCustom: boolean;
    public toDate: Date;
    public selectedEnvTypes: any[] = [];
    public waitingForResponse: boolean
    constructor(private store: Store, @Inject('$stateParams') private $stateParams: any) {
    }


    public async ngOnInit() {
        this.fromDate = null;
        this.toDate = null;
        this.selectedEnvironments = [null]
        this.setEnvs();
        this.unSubscribe = this.store.subscribe(() => {
            if (this.waitingForResponse && this.store.getState().project.projectEnvTypesWithEnvsAndDeployStatus) {

                this.store.getState().project.projectEnvTypesWithEnvsAndDeployStatus.forEach(obj => {

                    if (obj.environments) {
                        this.envTypes.push(obj);
                        obj.environments.forEach(env => this.envs.push(env));
                        this.waitingForResponse = false;
                    }

                })
                let ids = this.envs.map(obj => obj.id)
                this.$stateParams.envs = this.envs;
                this.getEnvs.emit(this.envs);
                if (ids.length > 0)
                    this.envs = [{ id: null, name: "All" }, ...this.envs];
                if (this.envTypes.length > 0)
                    this.envTypes = [{ id: null, name: "All" }, ...this.envTypes]
            }

        });


    }


    setEnvs() {
        this.selectedEnvironments = [];
        this.waitingForResponse = true;
        this.store.dispatch({
            type: projectActions.GET_PROJECT_ENV_TYPES_WITH_ENVS_AND_DEPLOY_STATUS,
            payload: {
                projId: this.$stateParams.id
            }
        })
    }


    envAllBtnClicked(item, envAllClickede) {

        if (item.name === "All") {
            this[envAllClickede] = !this[envAllClickede];
        }

    }



    selectedTime(data) {
        this.fromDate = data.value.fromDate;
        this.toDate = data.value.toDate;
        this.isCustom = (data.name == 'Custom') ? true : false;
        if (this.isCustom) {
            this.initFrom = false;
            this.initTo = false;
        }
    }

    ngOnDestroy() {
        this.envs = null;
        this.unSubscribe();
    }


    onFilter() {
        let fromDate = moment(this.fromDate);
        let toDate = moment(this.toDate);
        if (this.fromDate) {
            fromDate.startOf('day')
        }
        if (this.toDate) {
            toDate.endOf('day');
        }

        if (this.selectedEnvironments.includes(null)) {
            this.selectedEnvironments = []
        }

        if (this.selectedEnvTypes.includes(null)) {
            this.selectedEnvTypes = []
        }

        this.filter.emit({
            data: {
                envs: this.envs,
                pipelineId: this.$stateParams.id,
                environments: this.selectedEnvironments,
                environmentTypeId: this.selectedEnvTypes ? this.selectedEnvTypes : [],
                isValidated: this.selectedValidation,
                pageNumber: this.pageId,
                pageCount: this.quantity,
                startTime: fromDate.format('YYYY-MM-DDTHH:mm:ss'),
                endTime: toDate.format('YYYY-MM-DDTHH:mm:ss')
            }
        })

    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/buckups-ang7/backups-filter/backups-filter.component.ts